/** Display form of the engine version: ISO_COST_ENGINE_2_0 -> ISO_COST_ENGINE_2.0 */
export function formatEngineVersion(version) {
  if (!version) return '';
  return version.replace(/_(\d+)_(\d+)$/, '_$1.$2');
}
